module.exports = __webpack_public_path__ + "img/w2.04518a11.png";